/**
 * Converts the given input to an ISO 8601 date string if possible.
 *
 * @param {string|number|Date} input - The value to be converted to an ISO date string.
 * @returns {string|undefined} The ISO 8601 date string if the input is a valid date, otherwise undefined.
 */
function sanitizeToISODate(input) {
  const date = new Date(input);
  if (isNaN(date.getTime())) {
    return undefined;
  }
  return date.toISOString();
}

export { sanitizeToISODate };
